import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const GuideComponentStyles = (theme: Theme) =>
  createStyles({
    day: {
      width: "calc(100% / 7)",
      paddingTop: "calc(100% / 7)", 
      position: "relative",
    },
    custody : {
        width: '50%',
        height: '40%',
        position: 'absolute',
        bottom: '25%',
    },
    custodyName : {
        width: '100%',
        position: 'absolute',
        height: '40%',
        bottom: '25%',
        color: styleColors.white,
        fontSize: '12px',
        alignContent: 'center',
        textAlign: 'center',
        zIndex: 1,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
    borderBox: {
      borderTop: `1px solid ${styleColors.greyMedium1}`,
      borderRight: `1px solid ${styleColors.greyMedium1}`,
      width: "100%",
      height: "100%",
      position: "absolute",
      left: 0,
      bottom: 0,
      right: 0,
      top: 0,
      padding: "2px",
      boxSizing: "border-box",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
    firstDayOfweek: {
      borderLeft: `1px solid ${styleColors.greyMedium1}`,
    },
    lastWeekOfMonth: {
      borderBottom: `1px solid ${styleColors.greyMedium1}`,
    },
    otherMonth: {
      backgroundColor: styleColors.guideCellBackground,
      zIndex: 3,
    },
    otherMonthWknd: {
      backgroundColor: styleColors.guideCellSelected,
      zIndex: 3,
    },
    
    text: { // OK
      textOverflow: "ellipsis",
      textAlign: "left",
      font: "8px 'Metropolis', 'Helvetica', 'Arial', sans-serif",
    },
    whiteIcon: {
      color: styleColors.charcoalAlpha29,
    },
    dayName: { // OK
      width: "calc(100% / 7)",
      textAlign: "center",
      overflow: "hidden",
      fontWeight: 200,
      borderTop: `1px solid ${styleColors.blackInset33}`,
      textTransform: "uppercase",
      fontSize: "10px",
      padding: "4px 0px",
    },
    row: { // OK
      display: "flex",
      flexDirection: "row",
    },
    buttonsRow: {
      display: "flex",
      placeContent: "space-between",
      width: "100%",
      alignItems: "center",
    },
    title: {
      width: "100%",
      height: "35px",
      fontSize: "16px",
      fontWeight: 600,
      color: styleColors.greyDark3,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    newcalendar: {
      width: "100%",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    newcalendarTextualDisplay: {
      display: "flex",
      flexDirection: "column",
      borderStyle: "solid",
      borderWidth: "1px",
      borderRadius: "5px",
      alignItems: "center",
      padding: "5px",
      paddingBottom: "10px",
    },
  });



// WEBPACK FOOTER //
// ./src/components/guide/components/guidecomponent.styles.ts